module.exports = __webpack_public_path__ + "img/9791187206606.bda05727.jpg";